// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields} = state;

	/**
	 * If you're a minor your guardians need to be on the document
	 */
	let needsGuardianToSign = false;
	if (fields.customer_social_security_number.startsWith("20")) {
		const dateOfBirthYear = fields.customer_social_security_number.substring(0, 4);
		const dateOfBirthMonth = fields.customer_social_security_number.substring(4, 6);
		const dateOfBirthDay = fields.customer_social_security_number.substring(6, 8);
		const dateOfBirth = new Date(dateOfBirthYear + "-" + dateOfBirthMonth + "-" + dateOfBirthDay);

		const date18yearsAgo = new Date();
		date18yearsAgo.setFullYear(date18yearsAgo.getFullYear() - 18);

		if (dateOfBirth > date18yearsAgo) {
			needsGuardianToSign = true;
		}
	}

	if (needsGuardianToSign) {
		if (fields.caretaker_name_1.length === 0 || !Validator.validateSsn(fields.caretaker_ssn_1) ||
			fields.caretaker_name_2.length === 0 || !Validator.validateSsn(fields.caretaker_ssn_2)) {
			return false;
		}
	}

	/**
	 * If you're not a tax resident of Sweden you can't open an ISK account
	 */
	if (!fields.radio_customer_kyc_taxdom.options[1].checked) {
		return false;
	}

	/**
	 * PEP persons need to specify the type of PEP and relationship
	 */
	if (!fields.radio_customer_pep.options[0].checked) {
		if (!fields.radio_customer_pep.options[1].checked || fields.radio_customer_pep_details.index === -1) {
			return false;
		}
	}

	if (!fields.radio_customer_pep_past.options[0].checked) {
		if (!fields.radio_customer_pep_past.options[1].checked || fields.radio_customer_pep_past_details.index === -1) {
			return false;
		}
	}

	/**
	 * FATCA persons can't open an account ever
	 */
	if (fields.radio_customer_us_person.options[1].checked || !fields.radio_customer_us_person.options[0].checked) {
		return false;
	}

	return !!(
		fields.customer_firstname.length > 0
		&& fields.customer_lastname.length > 0
		&& Validator.validateSsn(fields.customer_social_security_number, true)
		&& fields.customer_address_street.length > 0
		&& fields.customer_address_zipcode.length > 0
		&& fields.customer_address_city.length > 0
		&& fields.customer_phonenumber_cell.length > 0
		&& Validator.validateEmail(fields.customer_email)
	);
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/CustomerInformation/fair-gds-oppna/CustomerInformation.fulfillment.js